import {IconEye, IconEyeClosed} from "../icons/icons";
import React, {HTMLProps, Ref, useEffect, useRef, useState} from "react";
import {mergeRefs} from "use-callback-ref";

type Props = HTMLProps<HTMLInputElement>

export const PasswordInput = React.forwardRef((props: Props, ref: Ref<HTMLInputElement>) => {
  const isInitialMount = useRef(true);
  const inputRef = useRef<HTMLInputElement>(null);
  const bigRef = mergeRefs([inputRef, ref])
  const [showPassword, setShowPassword] = useState<boolean>(false);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      inputRef.current?.focus();
    }
  }, [showPassword])

  const type = showPassword ? "text" : "password";
  const inputProps = {...props, type, className: props.className + " pr-12"}
  const toggleShowPassword = async () => {
    setShowPassword(current => !current);
  }
  const icon = showPassword ? showPasswordIcon : hidePasswordIcon
  return <div className="relative">
    <input ref={bigRef} {...inputProps} />
    <button
        type={"button"}
        className="absolute right-2 top-2 bottom-2 p-1.5"
        onClick={toggleShowPassword}
        data-testid="password-toggle-visible"
        aria-label={showPassword ? "hide password" : "show password"}
    >
      {icon}
    </button>
  </div>
});

const showPasswordIcon = <IconEyeClosed/>;
const hidePasswordIcon = <IconEye/>;
